(function(){
  // Adds a small "NEW" badge to the Tropical Glow option in the buy-box flavour
  // dropdowns (lander only). Re-applies on every re-render of the picker.
  var NEWFLAV='tropical-glow';
  function tag(){
    var opts=document.querySelectorAll('#kai-flavours button[data-fid="'+NEWFLAV+'"]');
    for(var i=0;i<opts.length;i++){
      var btn=opts[i];
      if(btn.querySelector('.kai-newbadge')) continue;
      btn.style.position='relative';
      btn.style.overflow='visible';
      var b=document.createElement('span');
      b.className='kai-newbadge';
      b.textContent='NEW';
      b.style.cssText='position:absolute;top:-7px;right:-6px;background:#F2913D;color:#fff;font-size:8px;font-weight:800;letter-spacing:.04em;padding:2px 5px;border-radius:20px;box-shadow:0 1px 4px rgba(0,0,0,.25);line-height:1;pointer-events:none;z-index:2';
      btn.appendChild(b);
    }
  }
  function start(){
    var host=document.getElementById('kai-flavours');
    if(host){ try{ new MutationObserver(function(){ tag(); }).observe(host,{childList:true,subtree:true}); }catch(e){} }
    tag(); setTimeout(tag,400); setTimeout(tag,1200);
  }
  if(document.readyState!=='loading') start(); else document.addEventListener('DOMContentLoaded',start);
})();
